import React, { useEffect, useRef, useState } from 'react';
import {
  PostBox,
  PriorityStyle,
  UserDetails,
  UserProfile,
} from './Home.style';
import { ReactComponent as ProfilePic } from 'assert/images/Common/profileImg.svg';
import { SuggestionsStyle, UserInfo } from './Content.style';
import { Button } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  PostMessageReceive,
  changePostRelations,
  getFollowersSuggestionsList,
} from 'redux/features/ActivityPostSlice';
import { Notification } from 'components/CustomNotification';
import DynModel from 'components/Modal';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Suggestions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const disableRecall = useRef(true);
  const { t } = useTranslation();

  const { PostMessage } = useSelector((state) => state.PostActivitySlice);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const loggedInUserId = getProfile?.userId;

  const [suggestionsList, setSuggestionsList] = useState([]);
  const [listWithDrawID, setListWithDrawID] = useState([]);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [openConfirmModel, setOpenConfirmModel] = useState(null);

  useEffect(() => {
    if(disableRecall.current){
      disableRecall.current= false;
      dispatch(getFollowersSuggestionsList(0, 10, true))
        .then((res) => {
          const response = res?.data;
          setSuggestionsList([...response.rows, ...suggestionsList]);
        })
        .catch(() => {
          Notification('warning', 'Something went wrong');
        });
    }
  }, []);

  useEffect(() => {
    if (PostMessage?.status) {
      dispatch(PostMessageReceive(''));
      if (PostMessage?.type === 'FOLLOW') {
        setListWithDrawID([PostMessage?.data?.followerId, ...listWithDrawID]);
      } else if (
        PostMessage?.type === 'WITHDRAW' ||
        PostMessage?.type === 'UNFOLLOW'
      ) {
        setListWithDrawID(
          listWithDrawID.filter(
            (list) => list !== PostMessage?.data?.followerId
          )
        );
        setOpenConfirmModel(null);
      }
      setIsLoadingBtn(false);
    } else if (!PostMessage?.status) {
      setIsLoadingBtn(false);
      setOpenConfirmModel(null);
    }
  }, [PostMessage]);

  const StatusChangeFun = (followerId, key) => {
    dispatch(
      changePostRelations({
        followerId,
        key,
        userId: loggedInUserId,
      })
    );
  };

  const handleFollowAction = (data) => {
    const { isAutoFollowRequest, followerUserId } = data;
    return !listWithDrawID.includes(followerUserId) ? (
      <Button
        loading={isLoadingBtn}
        label={t('HomePage.Follow')}
        onClick={() => StatusChangeFun(followerUserId, 'FOLLOW')}
        variant={'outlined'}
        customStyles="suggestion-fol-btn"
      />
    ) : isAutoFollowRequest ? (
      <Button
        loading={isLoadingBtn}
        label={t('HomePage.Unfollow')}
        color={'error'}
        onClick={() => StatusChangeFun(followerUserId, 'UNFOLLOW')}
        variant={'outlined'}
        customStyles="suggestion-fol-btn"
      />
    ) : (
      <Button
        loading={isLoadingBtn}
        label={t('HomePage.Withdraw')}
        onClick={() => setOpenConfirmModel(data)}
        variant={'outlined'}
        customStyles="suggestion-fol-btn"
      />
    );
  };

  return (
    <PriorityStyle className="priorityStyle">
      <div className='suggestion-title'>
        <div>{t('HomePage.YouMightLike')}</div>
        <Button
          variant="text"
          label={t('HomePage.SeeMore')}
          onClick={() => navigate('/network/suggestions')}
        />
      </div>
      <SuggestionsStyle>
        {suggestionsList?.map((data, index) => (
          <PostBox key={index}>
            <UserInfo
              className="suggestion-user-info"
              customcss={'space-between'}
            >
              <div className="about-info">
                <UserProfile>
                  {data?.profileImage ? (
                    <img src={data?.profileImage} alt="profile-picture" />
                  ) : (
                    <ProfilePic />
                  )}
                </UserProfile>
                <UserDetails className='username-suggestion'>
                  <div className="user-role" onClick={()=>navigate('/profile/' + data?.username)} title={data.username}>{data.username}</div>
                  <div className="followers">
                    {(data.followerInfo.followerCount || 0) + ' ' + t('HomePage.Followers')}
                  </div>
                </UserDetails>
              </div>
              {handleFollowAction({
                isAutoFollowRequest:
                  data?.autoFollowRequest ||
                  data?.followerInfo?.autoFollowRequest,
                followerUserId: data?.followerInfo?.userId,
              })}
            </UserInfo>
            {data.headline && (
              <div className="user-headline">{data.headline}</div>
            )}
          </PostBox>
        ))}
      </SuggestionsStyle>

      <DynModel
        removeHeader
        modalchanges="network"
        handleCancelModal={() => setOpenConfirmModel(null)}
        openModal={openConfirmModel !== null}
        content={
          <div className="confirmModal">
            <div className="title">{t('Network.WithDrawModal')}</div>
            <div className="sub-title">
              {t(`Network.RequestForTwoDays`)}
            </div>
            <div>
              <Button
                label={t(`Network.Cancel`)}
                variant="text"
                onClick={() => setOpenConfirmModel(null)}
              />
              <Button
                label={t(`Network.Yes`)}
                color="error"
                onClick={() =>
                  StatusChangeFun(openConfirmModel?.followerUserId, 'WITHDRAW')
                }
              />
            </div>
          </div>
        }
      />
    </PriorityStyle>
  );
}